(function () {
  function selectRandomBlogImage(container) {
    if (!container || container.dataset.randomImageInitialized === 'true') return;

    var images = container.querySelectorAll('[data-jiyucho-info-blog-image]');
    if (!images.length) return;

    container.dataset.randomImageInitialized = 'true';

    var selectedIndex = Math.floor(Math.random() * images.length);
    Array.prototype.forEach.call(images, function (image, index) {
      if (index === selectedIndex && !image.getAttribute('src')) {
        image.setAttribute('src', image.getAttribute('data-src'));
      }
      image.hidden = index !== selectedIndex;
    });
  }

  function setupRandomBlogImages(root) {
    var scope = root || document;
    var containers = scope.querySelectorAll
      ? scope.querySelectorAll('[data-jiyucho-info-blog-images]')
      : [];

    Array.prototype.forEach.call(containers, selectRandomBlogImage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setupRandomBlogImages(document);
    });
  } else {
    setupRandomBlogImages(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    setupRandomBlogImages(event.target);

    if (event.target.matches && event.target.matches('[data-jiyucho-info-blog-images]')) {
      selectRandomBlogImage(event.target);
    }
  });
})();
